import React, { useState, useEffect, useRef } from 'react';
import './EquipoSection.css';

const frasesTitulo = [
  'CONOCE EL EQUIPO',
  'MASTERS DEL NETWORKING'
];

const equipo = [
  {
    nombre: 'Fernando Castillo',
    rol: 'Expansión Global',
    img: '/images/equipo/1.jpg',
    bio: {
      nombre: 'Fernando Castillo',
      rol: 'Expansión Global',
      cita: 'Conecto personas para crear oportunidades.',
      institucion: 'Instituto Tecnológico de Morelia'
    },
    hasBio: true,
  },
  {
    nombre: '',
    rol: 'RODÉATE DE GIGANTES',
    img: '/images/RecomiendaT-logo.png',
    isLogo: true,
  },
  {
    nombre: 'Valentina Galán',
    rol: 'CEO',
    img: '/images/equipo/2.jpg',
    bio: {
      nombre: 'Valentina Galán',
      rol: 'CEO',
      cita: 'Creo experiencias que inspiran y conectan.',
      institucion: 'Lic. en Turismo'
    },
    hasBio: true,
  },
];

export default function EquipoSection() {
  // Slider de título
  const [tituloIndex, setTituloIndex] = useState(0);
  const [tituloAnim, setTituloAnim] = useState('slide-in');
  const tituloTimeout = useRef();
  useEffect(() => {
    setTituloAnim('slide-in');
    tituloTimeout.current = setTimeout(() => {
      setTituloAnim('slide-out');
      setTimeout(() => {
        setTituloIndex(i => (i + 1) % frasesTitulo.length);
        setTituloAnim('slide-in');
      }, 500);
    }, 2500);
    return () => clearTimeout(tituloTimeout.current);
  }, [tituloIndex]);

  return (
    <section className="equipo-section">
      <h2 className="equipo-titulo">
        <span className={`equipo-titulo-slider ${tituloAnim}`}>{frasesTitulo[tituloIndex]}</span>
      </h2>
      <div className="equipo-grid">
        {equipo.map((persona, i) => (
          <div className="equipo-card" key={i} style={{ animationDelay: `${i * 0.13}s` }}>
            <div className="equipo-card-inner">
              <div className="equipo-card-front">
                <div className={`equipo-img-container ${persona.isLogo ? 'equipo-logo-container' : ''}`}>
                  <img 
                    src={persona.img} 
                    alt={persona.isLogo ? 'RecomiendaT Logo' : persona.nombre} 
                    className={persona.isLogo ? 'equipo-logo' : 'equipo-img'} 
                    draggable="false" 
                  />
                </div>
                {!persona.isLogo && <div className="equipo-nombre">{persona.nombre}</div>}
              </div>
              <div className="equipo-card-back">
                {persona.hasBio ? (
                  <div className="equipo-bio">
                    <div className="equipo-bio-nombre">{persona.bio.nombre}</div>
                    <div className="equipo-bio-rol">{persona.bio.rol}</div>
                    <div className="equipo-bio-cita">"{persona.bio.cita}"</div>
                    <div className="equipo-bio-institucion">{persona.bio.institucion}</div>
                  </div>
                ) : (
                  <div className="equipo-rol-back">{persona.rol}</div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
} 